import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const activateLifeMartAccess = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .validator((input: { code: string; signupSource?: string | null }) => input)
  .handler(async ({ data, context }) => {
    const { activateLifeMartMembership } = await import("./lifemart.server");
    return activateLifeMartMembership({
      userId: (context as any).userId,
      code: data.code,
      signupSource: data.signupSource,
    });
  });
